import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Button, Typography, Divider } from '@material-ui/core';
import { handleSnackBar, invokePostService } from '../../../store/global/actions';
import Dialog from "../../atoms/dialog";

export default function DeleteDatabaseSampleData({ delegateId, onClose, onCompletion }) {
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const onDelete = () => {
        setLoading(true);
        dispatch(invokePostService('deleteDatabaseSampleData', {}, [delegateId])).then(res => {
            if (res?.status === true) {
                dispatch(handleSnackBar({ open: true, message: "Database sample data deleted", severity: "success" }));
                onCompletion();
            }
            setLoading(false);
        });
    }

    return (
        <Dialog
            open={true}
            handleClose={onClose}
            paperProps={{ id: "deleteSampleDataAlert" }}
        >

            <Grid container direction={"row"} spacing={1} >
                <Grid item xs={12} >
                    <Typography variant="h6">Delete</Typography>
                </Grid>
                <Grid item xs={12} >
                    <Divider />
                </Grid>


                <Grid item xs={12} style={{ padding: '10px' }}>
                    <Typography style={{ marginBottom: '10px' }}> Are you sure you want to delete database sample data? </Typography>
                </Grid>
                <Grid item xs={12} >
                    <Divider />
                </Grid>

                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }} >
                    <Button color="primary" variant="outlined" style={{ marginLeft: 10, textTransform: 'capitalize' }} onClick={onClose}> Cancel </Button>
                    <Button color="secondary" variant="contained" style={{ marginLeft: 10, textTransform: 'capitalize' }} onClick={onDelete} disabled={loading}> {loading ? 'Deleting..' : 'Delete'} </Button>
                </Grid>
            </Grid >

        </Dialog >
    )
}
